import { render, staticRenderFns } from "./ActivateAddendumButton.vue?vue&type=template&id=6512bb57&scoped=true&"
import script from "./ActivateAddendumButton.vue?vue&type=script&lang=js&"
export * from "./ActivateAddendumButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6512bb57",
  null
  
)

export default component.exports